import $ from 'jquery'
import { initializeVideoPlayer } from '~/common/components/videojs/main'

const openVideoLinkLightbox = (e) => {
  e.preventDefault()
  const link = $(e.target)
  if (link.data('opening')) {
    return
  }
  link.data('opening', true)
  const href = link.attr('href')
  const asset_id = href.match(/uploads\/asset\/file\/(\d+)\//)[1]
  if (asset_id != null) {
    link.css('opacity', '0.5')

    return $.ajax({
      url: `/videoplayer/${asset_id}.js`,
      method: 'GET',
      success(data, _status) {
        if (data.video == null) {
          link.css('opacity', '').data('opening', false)
          return (window.location = href)
        } else {
          const maxHeight = 95
          const padding = 1
          $('.lightbox-wrapper').remove()
          $('body').append(`\
<div class="lightbox-wrapper" style="display: none"><div class="lightbox" style="max-height: ${maxHeight}vh; padding:${padding}rem;">
<a href="javascript:void(0);" class="lightbox__btn-close">&times;</a>
<div class="lightbox__content"></div>
</div></div>\
`)

          const video = $(data.video)
            .attr('autoplay', 'autoplay')
            .data('max-height', null)
          const ratio = video.data('ratio')
          $('.lightbox__content')
            .css(
              'max-width',
              `calc(${maxHeight * ratio}vh - ${2 * padding * ratio}rem)`
            )
            .append(video)
          initializeVideoPlayer($('.lightbox__content video'))

          $('.lightbox-wrapper')
            .stop()
            .fadeIn(500, function () {
              link.css('opacity', '').data('opening', false)
              // Safari won't allow this, but not much we can do about it
              const player = $('.lightbox__content video').data(
                'videojs-player'
              )
              player.play()
            })
        }
      },
    })
  }
}

const closeVideoLinkLightbox = (e) => {
  // We only want to close if the close button or the overlay are clicked. We don't want to close if their descendents
  // are clicked. The video is the descendent of the overlay!
  if (e.target !== e.currentTarget) return

  // In case we're still fading in or if there was an error above, stop()
  $('.lightbox-wrapper').stop().fadeOut(500)
  setTimeout(() => $('.lightbox__content').empty(), 510)
}

$(document).on(
  'click',
  "a.btn[href*='/uploads/asset/file/'][href*=mp4]:not([target='_blank'])",
  openVideoLinkLightbox
)

$(document).on(
  'click',
  '.lightbox__btn-close, .lightbox-wrapper',
  closeVideoLinkLightbox
)
